(function(){
  "use strict";

  function money(cents,fmt){
    fmt=fmt||'${{amount}}';
    var m=fmt.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var token=m?m[1]:'amount';
    var dec=2,thou=',',point='.';
    if(token.indexOf('with_comma_separator')>-1){thou='.';point=',';}
    if(token.indexOf('no_decimals')>-1) dec=0;
    var parts=(cents/100).toFixed(dec).split('.');
    var out=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,thou)+(dec>0?point+parts[1]:'');
    return m?fmt.replace(m[0],out):fmt+out;
  }

  function dragScroll(el){
    var down=false,sx=0,ss=0,moved=false;
    el.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse') return; down=true;moved=false;sx=e.clientX;ss=el.scrollLeft;el.classList.add('dragging');el.style.scrollSnapType='none'; });
    window.addEventListener('pointermove',function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; el.scrollLeft=ss-dx; });
    window.addEventListener('pointerup',function(){
      if(!down) return; down=false; el.classList.remove('dragging'); el.style.scrollSnapType='';
      var w=el.firstElementChild?el.firstElementChild.getBoundingClientRect().width:el.clientWidth;
      el.scrollTo({left:Math.round(el.scrollLeft/w)*w,behavior:'smooth'});
    });
    el.addEventListener('click',function(e){ if(moved){e.preventDefault();e.stopPropagation();moved=false;} },true);
  }

  function initGallery(root){
    var g=root.querySelector('[data-glc-gallery]');
    if(!g) return;
    var track=g.querySelector('.glc-gal-track');
    var slides=track.children;
    var dotsWrap=root.querySelector('[data-glc-dots]');
    var dots=[];
    for(var i=0;i<slides.length;i++){ var d=document.createElement('span'); if(i===0) d.className='on'; dotsWrap.appendChild(d); dots.push(d); }
    function idx(){ return Math.round(track.scrollLeft/track.clientWidth); }
    function go(n){ n=Math.max(0,Math.min(slides.length-1,n)); track.scrollTo({left:n*track.clientWidth,behavior:'smooth'}); }
    track.addEventListener('scroll',function(){ var n=idx(); dots.forEach(function(d,j){ d.classList.toggle('on',j===n); }); },{passive:true});
    g.querySelector('.prev').addEventListener('click',function(){ go(idx()-1); });
    g.querySelector('.next').addEventListener('click',function(){ go(idx()+1); });
    dragScroll(track);
  }

  function initPacks(root){
    var fmt=root.getAttribute('data-glc-money');
    var packs=Array.prototype.slice.call(root.querySelectorAll('.glc-pack'));
    var idInput=root.querySelector('[data-glc-variant-input]');
    var atc=root.querySelector('[data-glc-atc]');
    root.glcEnded=false;
    function apply(p){
      var price=parseInt(p.getAttribute('data-price'),10);
      var compare=parseInt(p.getAttribute('data-compare'),10);
      var pay=root.glcEnded?compare:price;
      if(idInput) idInput.value=p.getAttribute('data-id');
      root.querySelectorAll('[data-glc-sum-val]').forEach(function(e){ e.textContent=money(compare,fmt); });
      root.querySelectorAll('[data-glc-sum-pay]').forEach(function(e){ e.textContent=money(pay,fmt); });
      root.querySelectorAll('[data-glc-sum-save]').forEach(function(e){ e.textContent=money(compare-pay,fmt); });
      root.querySelectorAll('[data-glc-countdown-compare]').forEach(function(e){ e.textContent=money(compare,fmt); });
      if(atc){ var av=p.getAttribute('data-available')!=='false'; atc.disabled=!av; atc.textContent=av?(atc.getAttribute('data-label')||'AGREGAR AL CARRITO'):'AGOTADO'; }
    }
    root.glcApply=function(){ var s=root.querySelector('.glc-pack.selected')||packs[0]; if(s) apply(s); };
    packs.forEach(function(p){
      p.addEventListener('click',function(){ packs.forEach(function(o){o.classList.remove('selected');}); p.classList.add('selected'); apply(p); });
    });
    root.glcApply();
  }

  function initCountdown(root){
    var el=root.querySelector('[data-glc-countdown]');
    if(!el) return;
    function nextMidnight(){ var d=new Date(); d.setHours(24,0,0,0); return d.getTime(); }
    var end=nextMidnight();
    function p(n){return n<10?'0'+n:''+n;}
    function tick(){
      var d=end-Date.now();
      if(d<=0){ end=nextMidnight(); d=end-Date.now(); }
      var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      el.textContent=p(h)+':'+p(m)+':'+p(s);
    }
    tick(); setInterval(tick,1000);
  }

  function initAccordions(root){
    root.querySelectorAll('.glc-acc-head').forEach(function(h){
      h.addEventListener('click',function(){
        var item=h.parentElement; item.classList.toggle('open');
        var sym=h.querySelector('.sym'); if(sym) sym.innerHTML=item.classList.contains('open')?'&minus;':'+';
      });
    });
  }

  function initScrollCtas(root){
    var target=root.querySelector('#glc-buy-anchor');
    root.querySelectorAll('[data-glc-scroll]').forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        if(target) window.scrollTo({top:target.getBoundingClientRect().top+window.pageYOffset-10,behavior:'smooth'});
      });
    });
  }

  function initLightbox(root){
    var box=root.querySelector('.glc-lightbox'); if(!box) return;
    var img=box.querySelector('img');
    root.querySelectorAll('[data-glc-zoom]').forEach(function(el){ el.addEventListener('click',function(){ img.src=el.currentSrc||el.src; box.classList.add('open'); }); });
    box.querySelector('.close').addEventListener('click',function(){ box.classList.remove('open'); });
    box.addEventListener('click',function(e){ if(e.target===box) box.classList.remove('open'); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') box.classList.remove('open'); });
  }

  function initPopup(root){
    var el=root.querySelector('[data-glc-popup]'); if(!el) return;
    var country=root.getAttribute('data-glc-country')||'co';
    var list={
      co:[{n:'Patricia',c:'Bogot\u00e1'},{n:'Luz Marina',c:'Medell\u00edn'},{n:'Carlos',c:'Cali'},{n:'Gloria',c:'Barranquilla'},{n:'Jorge',c:'Bucaramanga'},{n:'Sandra',c:'Pereira'}],
      gt:[{n:'Patricia',c:'Ciudad de Guatemala'},{n:'Rosa',c:'Quetzaltenango'},{n:'Carlos',c:'Mixco'},{n:'Gloria',c:'Villa Nueva'},{n:'Jorge',c:'Escuintla'},{n:'Sandra',c:'Antigua Guatemala'}]
    };
    var buyers=list[country]||list.co;
    var txt=el.querySelector('[data-glc-popup-text]');
    var closed=false,i=0;
    function show(){
      if(closed) return;
      var b=buyers[i%buyers.length];
      txt.innerHTML='<b>'+b.n+'</b> de '+b.c+' compr\u00f3 Gluco Tone hace '+(Math.floor(Math.random()*20)+2)+' minutos';
      el.classList.add('show'); i++;
      setTimeout(function(){ el.classList.remove('show'); },5000);
    }
    el.querySelector('[data-glc-popup-close]').addEventListener('click',function(){ closed=true; el.classList.remove('show'); });
    setTimeout(show,5000);
    setInterval(function(){ if(!el.classList.contains('show')) show(); },15000);
  }

  function initLazyVideos(root){
    var vids=root.querySelectorAll('[data-glc-lazy-video]');
    if(!vids.length) return;
    function start(){
      if(!('IntersectionObserver' in window)){ vids.forEach(function(v){ v.src=v.getAttribute('data-src'); v.play().catch(function(){}); }); return; }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var v=e.target;
          if(e.isIntersecting){
            if(!v.getAttribute('src')){ v.src=v.getAttribute('data-src'); v.load(); }
            var p=v.play(); if(p) p.catch(function(){});
          } else if(v.getAttribute('src')){ v.pause(); }
        });
      },{rootMargin:'150px 0px',threshold:0.25});
      vids.forEach(function(v){ io.observe(v); });
    }
    if(document.readyState==='complete') start(); else window.addEventListener('load',start);
  }

  function init(){
    document.querySelectorAll('.glc[data-glc-root]').forEach(function(root){
      initGallery(root);
      initPacks(root);
      initCountdown(root);
      initAccordions(root);
      initScrollCtas(root);
      initLightbox(root);
      initPopup(root);
      initLazyVideos(root);
      root.querySelectorAll('[data-glc-review-slider]').forEach(dragScroll);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
